import { z } from "zod";
import {
	audienceCreateSchema,
	audienceSearchSchema,
	audienceWithStatusSchema,
	responseSchema,
} from "./audience.schemas";

// List Audiences API
export const listAudiencesQueryParamsSchema = z
	.object({
		type: z
			.enum(["member", "event", "default", "campaign", "survey", "lottery"])
			.optional(),
	})
	.optional();

/**
 * @description A list of audience groups with status information
 */
export const listAudiences200Schema = z.object({
	data: z.array(audienceWithStatusSchema),
	message: z.coerce.string(),
	success: z.coerce
		.string()
		.transform((val) => val === "true" || val === "1")
		.refine((val) => typeof val === "boolean", {
			message:
				"Query param must be 'true' or '1', otherwise it will default to false",
		}),
});

/**
 * @description Bad request
 */
export const listAudiences400Schema = z.lazy(() => responseSchema);

/**
 * @description Internal server error
 */
export const listAudiences500Schema = z.lazy(() => responseSchema);

export const listAudiencesQueryResponseSchema = z.lazy(
	() => listAudiences200Schema,
);

// Search Audience API
export const searchAudienceMutationRequestSchema = audienceSearchSchema;

/**
 * @description Successfully found matching members count
 */
export const searchAudience200Schema = z.object({
	count: z.coerce.number().int().min(0),
	message: z.coerce.string(),
	success: z.coerce
		.string()
		.transform((val) => val === "true" || val === "1")
		.refine((val) => typeof val === "boolean", {
			message:
				"Query param must be 'true' or '1', otherwise it will default to false",
		}),
});

/**
 * @description Bad request
 */
export const searchAudience400Schema = z.lazy(() => responseSchema);

/**
 * @description Internal server error
 */
export const searchAudience500Schema = z.lazy(() => responseSchema);

export const searchAudienceMutationResponseSchema = z.lazy(
	() => searchAudience200Schema,
);

// Create Audience API
export const createAudienceMutationRequestSchema = audienceCreateSchema;

/**
 * @description Successfully created audience group
 */
export const createAudience200Schema = z.object({
	audienceGroupId: z.coerce.string().optional(),
	message: z.coerce.string(),
	success: z.coerce
		.string()
		.transform((val) => val === "true" || val === "1")
		.refine((val) => typeof val === "boolean", {
			message:
				"Query param must be 'true' or '1', otherwise it will default to false",
		}),
});

/**
 * @description Bad request
 */
export const createAudience400Schema = z.lazy(() => responseSchema);

/**
 * @description Internal server error
 */
export const createAudience500Schema = z.lazy(() => responseSchema);

export const createAudienceMutationResponseSchema = z.lazy(
	() => createAudience200Schema,
);

// Delete Audience API
export const deleteAudiencePathParamsSchema = z.object({
	audienceGroupId: z.coerce.string().describe("ID of audience group to delete"),
});

/**
 * @description Successfully deleted audience group
 */
export const deleteAudience200Schema = z.object({
	message: z.coerce.string(),
	success: z.coerce
		.string()
		.transform((val) => val === "true" || val === "1")
		.refine((val) => typeof val === "boolean", {
			message:
				"Query param must be 'true' or '1', otherwise it will default to false",
		}),
});

/**
 * @description Bad request
 */
export const deleteAudience400Schema = z.lazy(() => responseSchema);

/**
 * @description Audience group not found
 */
export const deleteAudience404Schema = z.lazy(() => responseSchema);

/**
 * @description Internal server error
 */
export const deleteAudience500Schema = z.lazy(() => responseSchema);

export const deleteAudienceMutationResponseSchema = z.lazy(
	() => deleteAudience200Schema,
);
